<template>
    <div id="bottom">
        <img src="@/assets/bottom/banner.png" alt="" class="banner"  @click="showtc2=true">
        <div class="bottom1">
            <div>
                <img :src="url+msg[0].image" alt="" class="code">
                <p>{{msg[0].title}}</p>
            </div>
            <ul>
                <li v-for="(item,index) in list" :key="index" v-show="index<4">
                    <p>{{item.title}}</p>
                    <p @click="jumppage(list.url,list.jumptype)" v-for="(list,i) in item.pagelist" :key="i">{{list.title}}</p>
                </li>
                <li v-for="(item,index) in list" :key="index" v-show="index>3">
                    <p>{{item.title}}</p>
                    <p @click="jumparticle(list.id)" v-for="(list,i) in item.pagelist" :key="i">{{list.title}}</p>
                </li>
            </ul>
        </div>
        <div class="bottom2">
            <p class="p1">{{msg[1].title}}</p>
            <p class="p2" v-html="msg[1].subtitle"></p>
            <p class="p3" v-html="msg[2].title+msg[2].subtitle"></p>
        </div>
        <div class="bottom3" @click="jumppage(msg[3].router,msg[3].type)">
            <span>{{msg[3].title}}</span>
            <span v-html="msg[3].subtitle"></span>
        </div>
        <div class="bottom4" v-show="showtc">
            <div>
                <p class="title">扫码立即咨询更多</p>
                <img :src="url+msg[1].image" alt="" class="code" @click="jumppage(msg[1].router,msg[1].type)">
                <p class="phone">
                    <img src="@/assets/bottom/phone.png" alt="">
                    <span v-html="msg[1].subtitle"></span>
                </p>
                <img src="@/assets/bottom/close.png" alt="" class="close" @click="showtc=false"> 
            </div>
            <p class="button" @click="showtc2=true">立即咨询</p>
        </div>
        <mydialog v-if="showtc2" @tcstatus="tcstatus"></mydialog>
    </div>
</template>

<script>
var that
import mydialog from '@/components/dialog/dialog.vue'
import { bottom } from '@/api/api'
export default {
    name:"bottom",
    components: {
        mydialog
    },
    data(){
        return{
            showtc:true,
            showtc2:false,
            url:window.url,
            msg:[],
            list:[
                {
                    title:"亿宝易拓客平台",
                    pagelist:[

                    ]
                },
                {
                    title:"傲友门店营销系统",
                    pagelist:[

                    ]
                },
                {
                    title:"傲友门店营销系统",
                    pagelist:[

                    ]
                },
                {
                    title:"关于我们",
                    pagelist:[
   
                    ]
                },
                {
                    title:"学堂资讯",
                    pagelist:[

                    ]
                },
            ]
        }
    },
    mounted(){
        that = this
        bottom().then((response) => {
            that.list[0].pagelist = response.data.data[1]
            that.list[1].pagelist = response.data.data[2]
            that.list[2].pagelist = response.data.data[3]
            that.list[3].pagelist = response.data.data[4]
            that.list[4].pagelist = response.data.data[5]
            that.msg = response.data.data[0]
        })
    },
    methods:{
        tcstatus(e){
            this.showtc2 = e
        },
        jumppage(e,jumptype){
            if(jumptype==0){
                if(e != this.$route.path) {
                    this.$router.push(e)
                }
            }else{
                location.href=e
            }
        },
        jumparticle(e){
            this.$router.push('/schoolDetails?id='+e)
        },
    }
}
</script>

<style lang="less">
    :root {
        --web-title-fontsize: 30px;
        --web-subtitle-fontsize: 22px;
        --web-text-fontsize: 16px;
    } 
    .bottom3{
        font-size: 12px;
        color: #eee;
        text-align: center;
        padding-bottom: 20px;
        cursor: pointer;
        span:nth-child(1){
            margin-right: 10px;
        }
    }
    @media (min-width:750px) {
        #bottom{
            background-color: #161F30;
            .banner{
                width: 100%;
                display: block;
                cursor: pointer;
            }
            .bottom1{
                width: 1400px;
                margin:0 auto;
                color: #fff;
                padding-top: 50px;
                display: flex;
                // justify-content: space-between;
                align-items: center;
                div{
                    img{
                        width: 183px;
                    }
                    p{
                        text-align: center;
                        font-size: 16px;
                        margin-top: 30px;
                    }
                    margin-right: 106px;
                }
                ul{
                    display: flex;
                    justify-content: space-between;
                    li{
                        margin-right: 50px;
                        cursor: pointer;
                        p{
                            margin-bottom: 30px;
                            width: 100%;
                            overflow: hidden; 
                            white-space: nowrap; 
                            text-overflow: ellipsis;
                        }
                        p:nth-child(1){
                            font-size: 16px;
                        }
                    }
                    li:last-child{
                        margin-right: 0;
                    }
                }
            }
            .bottom2{
                width: 1400px;
                margin:0 auto;
                color: #fff;
                padding: 50px 0;
                .p1{
                    font-size: 16px;
                    font-weight: 400;
                    margin-bottom: 10px;
                }
                .p2{
                    font-size: 16px;
                    font-weight: 400;
                    margin-bottom: 10px;
                }
                .p3{
                    font-size: 16px;
                    font-weight: 400;
                }
            }
            .bottom4{
                position: fixed;
                right: 40px;
                top: 50%;
                transform: translateY(-50%);
                z-index: 999;
                div{
                    background: #FFFFFF;
                    box-shadow: 0px 3px 12px 1px rgba(66,69,70,0.1);
                    border-radius: 12px 12px 12px 12px;
                    padding: 10px;
                    text-align: center;
                    position: relative;
                    .title{
                        margin-bottom: 20px;
                    }
                    .code{
                        width: 100%;
                    }
                    .phone{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 16px;
                        img{
                            margin-right: 10px;
                        }
                    }
                    .close{
                        position: absolute;
                        top: -8%;
                        right: -8%;
                        width: 20px;
                        cursor: pointer;
                    }
                }
                .button{
                    background-color: #1472FF;
                    color:#fff;
                    margin-top: 20px;
                    border-radius: 20px;
                    padding: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                }
            }
        }
    }
    @media screen and (max-width:750px) {
        #bottom{
            background-color: #161F30;
            .banner{
                width: 100%;
                display: block;
            }
            .bottom1{
                width: 90%;
                margin:0 auto;
                color: #fff;
                padding-top: 50px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                div{
                    width: 100%;
                    img{
                        width: 183px;
                    }
                    p{   
                        font-size: 16px;
                        margin-top: 10px;
                    }
                }
                ul{
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    li{
                        flex:0 0 50%;
                        p{
                            margin-bottom: 30px;
                            width: 90%;
                            overflow: hidden; 
                            white-space: nowrap; 
                            text-overflow: ellipsis;
                        }
                        p:nth-child(1){
                            font-size: 20px;
                            margin-top: 20px;
                        }
                    }
                    li:last-child{
                        margin-right: 0;
                    }
                }
            }
            .bottom2{
                width: 90%;
                margin:0 auto;
                color: #fff;
                padding: 50px 0;
                .p1{
                    font-size: 16px;
                    font-weight: 400;
                    margin-bottom: 10px;
                }
                .p2{
                    font-size: 16px;
                    font-weight: 400;
                    margin-bottom: 10px;
                }
                .p3{
                    font-size: 12px;
                    font-weight: 400;
                }
            }
            .bottom4{
                display: none;
            }
        }
    }
</style>